/**
 * Enums for Blog Post API
 */

/**
 * Content format types supported by blog posts
 */
export enum ContentFormat {
  HTML = 'html',
  MARKDOWN = 'markdown'
}

/**
 * Publish status of blog posts
 */
export enum PublishStatus {
  DRAFT = 'draft',
  INTERNAL = 'internal',
  PUBLIC = 'public'
}

/**
 * Fields available for sorting blog posts
 */
export enum SortBy {
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
  TITLE = 'title',
  PUBLISH_STATUS = 'publishStatus'
}

/**
 * Sort order options
 */
export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc'
}

/**
 * Export format types
 */
export enum ExportFormat {
  HTML = 'html',
  MARKDOWN = 'markdown',
  JSON = 'json'
}
